var t = Object.defineProperty;
var c = (e, o, i) => o in e ? t(e, o, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[o] = i;
var s = (e, o, i) => c(e, typeof o != "symbol" ? o + "" : o, i);
import { CookieConsentsDTO as k } from "./main86.js";
class r {
  /**
   * CookieConsentsConfigDTO constructor
   * @param params - Partial configuration for the CookieConsentsConfigDTO
   */
  constructor(o) {
    /**
     * Whether or not to show the cookie notice
     */
    s(this, "showCookieNotice");
    /**
     * The user's cookie consent settings
     */
    s(this, "cookies");
    Object.assign(this, {
      showCookieNotice: o.showCookieNotice ?? !0,
      cookies: o.cookies ?? new k({})
    });
  }
}
export {
  r as CookieConsentsConfigDTO
};
